import React from 'react';
import { useUserAgreements, useAcceptUserAgreements } from 'apollo/user';
import { Trans, t } from '@lingui/macro';
import { Agreement } from 'types/generated';
import { AppNotificationBar } from '../AppNotificationBar';

const UserAgreements: React.FC = () => {
    const { userAgreements } = useUserAgreements();
    const acceptAgreements = useAcceptUserAgreements(
        userAgreements?.map(({ kind }: Agreement) => kind),
    );

    return userAgreements?.some(
        ({ requireUpdate }: Agreement) => requireUpdate,
    ) ? (
        <AppNotificationBar
            variant="informational"
            action={{
                children: t`I agree`,
                onClick: acceptAgreements,
            }}
        >
            <Trans id="UserAgreements.content">
                We've updated our terms and policy. Please let us know that you
                agree to our current{' '}
                <a
                    href="https://www.landr.com/terms-of-service/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Terms of Service
                </a>{' '}
                and{' '}
                <a
                    href="https://www.landr.com/privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Policy
                </a>
                .
            </Trans>
        </AppNotificationBar>
    ) : null;
};

export default UserAgreements;
